module.exports = __webpack_public_path__ + "media/images/frontend/required-364a8cd3ef637685d8f8b1e1bc4507db.svg";